import React from 'react';
import ContactView from 'flow/components/tickets/ContactView';
import BaseModal from 'flow/components/ui-components/BaseModal';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { Contact } from 'flow/types/Contact';
import { TypedMap } from 'flow/types/TypedMap';

interface Props {
    contact?: TypedMap<Contact>;
    // A calendar route in the host page's own section, for the card's link
    calendarPath?: string;
}

const ContactModalShell = ({ contact, calendarPath }: Props) => {
    const { i18next } = useAppContext();
    const { closeModal } = useModal();

    return (
        <BaseModal
            open={true}
            header={i18next.t('ContactCard.ContactCard')}
            disableActions={true}
            className="w-[700px]"
            useContactCardStyles={true}
        >
            <ContactView
                contact={contact}
                calendarPath={calendarPath}
                onNavigation={closeModal}
            />
        </BaseModal>
    );
};

export default ContactModalShell;
